import { Component, OnInit, OnChanges, Input, SimpleChange, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModeEnum, Params, PaymentMethodsEnum } from 'src/app/shared/enums/impulso.enum';
import { Parameter } from '../../models';
import { SearchService } from '../../services/ecosistemas/search.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { AlertService } from '../../services/alert.service';
import { EventoService } from '../../services/evento.service';

@Component({
    selector: 'app-basic-info-component',
    templateUrl: './basic-info-component.component.html',
    styleUrls: ['./basic-info-component.component.scss'],
})
export class BasicInfoComponentComponent implements OnInit, OnChanges {
    public daysOfTheWeek: Array<Parameter>;
    @Input() eventData: any;
    @Input() inscritoData: any;
    data: any;
    modeEnum = ModeEnum;
    selected = 0;
    hovered = 0;
    isRating = false;
    rating = 0;
    auxRating = 0;
    fecha = new Date().toISOString().split('T')[0];
    closeResult: string = '';
    urlCopiar: string;
    //Modalidad
    type_event: string;
    pay_event: string;
    vc_pasarela: string = '';
    vc_price: string = '';
    //Info extra
    descriptionEvent: string = '';
    descriptionEventExtra: string = '';
    descripcion: string = '';
    descripcionExtra: string = '';
    descripcionUrl: string = '';
    descripcionExtraUrl: string = '';
    dataDestacado: Array<any> = [];
    dataDestacado2: Array<any> = [];
    //Tipo Publico
    vc_edad: string[] = [];
    //Oferta campos
    horarios: Array<any>;
    textDinamico: string;
    grupoPoblacional: Array<Parameter>;
    grupoSocial: Array<Parameter>;

    constructor(
        private domSanitizer: DomSanitizer,
        private searchService: SearchService,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private alertService: AlertService,
        private eventoService: EventoService
    ) {}

    ngOnInit(): void {
        this.traerParametros();
    }

    traerParametros() {
        const requests = {
            daysOfTheWeek: this.searchService.getParamImpulso(Params.DAYS_OF_THE_WEEK),
            socialSectors: this.searchService.getParam(Params.DIFFERENTIAL_POPULATION_GROUPS),
            socialGroups: this.searchService.getParam(Params.ETHNIC_IDENTITY),
        };
        firstValueFrom(forkJoin(requests)).then(() => {
            this.daysOfTheWeek = this.searchService.daysOfTheWeekParam;
            this.grupoPoblacional = this.searchService.differentialPopulationGroupsParam;
            this.grupoSocial = this.searchService.ethnicIdentityParam;
            this.cdr.detectChanges();
        });
    }
    getModalidadNombre(value: number): string {
        return ModeEnum[value];
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['eventData'] && changes['eventData'].currentValue) {
            this.setTextoDinamico();
            this.data = changes['eventData'].currentValue;
            this.type_event = this.getModalidadNombre(this.data.i_fk_id_type_event || this.data.i_fk_id_type_offer);
            this.descriptionEventExtra = this.data.vc_description_event_extra || this.data.vc_description_offer_extra;
            this.getTipoPublico(this.data);
        }
        //Info extra
        if (this.descriptionEvent !== null && this.descriptionEvent !== undefined) {
            if (this.descriptionEvent !== '' && !this.descriptionEvent.startsWith('https://')) {
                this.descripcion = this.descriptionEvent;
            } else if (this.descriptionEvent !== '' && this.descriptionEvent.startsWith('https://')) {
                this.dataDestacado.push(this.domSanitizer.bypassSecurityTrustResourceUrl(this.getVideoIframe(this.descriptionEvent)));
            }

            if (this.descriptionEventExtra !== null && this.descriptionEventExtra !== undefined) {
                if (this.descriptionEventExtra !== '' && !this.descriptionEventExtra.startsWith('https://')) {
                    this.descripcionExtra = this.descriptionEventExtra;
                } else if (this.descriptionEventExtra !== '' && this.descriptionEventExtra.startsWith('https://')) {
                    this.dataDestacado2.push(this.domSanitizer.bypassSecurityTrustResourceUrl(this.getVideoIframe(this.descriptionEventExtra)));
                }
            }
        }

        //Pasarela de pago
        const medio_rm = this.eventData.event_price?.i_pk_id || this.eventData.offer_price?.i_pk_id;
        this.pay_event = this.eventData.event_price?.vc_nombre || this.eventData.offer_price?.vc_nombre;
        if (medio_rm === 322) {
            this.vc_pasarela = '';
            this.vc_price = '';
        } else if (medio_rm === 323) {
            this.vc_pasarela = this.eventData.vc_price_url_event || this.eventData.vc_price_url_offer;
            this.vc_price = '';
        } else {
            this.vc_pasarela = this.eventData.vc_price_url_event || this.eventData.vc_price_url_offer;
            this.vc_price = this.eventData.vc_price_event || this.eventData.vc_price_offer;
        }
    }

    //Calificación
    onRateChange(rating: number) {}

    //Info extra
    getVideoIframe(url: string): string {
        let video, results;
        if (url === null || url === '') {
            return '';
        } else if (url.startsWith('https://www.youtube.com/watch?v=')) {
            results = url.match('[\\?&]v=([^&#]*)');
            video = results === null ? url : results[1];
            return 'https://www.youtube.com/embed/' + video;
        } else if (url.startsWith('https://vimeo.com/')) {
            results = url.split('/');
            video = results[results.length - 1];
            return 'https://player.vimeo.com/video/' + video;
        } else {
            return url;
        }
    }

    //Obtener clasificación de edad
    getTipoPublico(eventData: any) {
        if (eventData.vc_public_type_zero === '1') {
            this.vc_edad.push('Infancia 0 - 3 años');
        }
        if (eventData.vc_public_type_three === '1') {
            this.vc_edad.push('Niños 3 - 12 años');
        }
        if (eventData.vc_public_type_twelve === '1') {
            this.vc_edad.push('Adolecencia 12 - 18 años');
        }
        if (eventData.vc_public_type_eigtheen === '1') {
            this.vc_edad.push('Juventud 18 - 28 años');
        }
        if (eventData.vc_public_type_twenty === '1') {
            this.vc_edad.push('Adulto 28 - 59 años');
        }
        if (eventData.vc_public_type_six === '1') {
            this.vc_edad.push('Adulto Mayor +60 años');
        }
        if (eventData.vc_public_type_all === '1') {
            this.vc_edad.push('Todo Público');
        }
    }

    getDias(dia: string): string {
        if (!this.daysOfTheWeek || this.daysOfTheWeek.length === 0) {
            return '';
        }
        const param = this.daysOfTheWeek.find((p) => p.id === dia);
        return param ? param.nombre : '';
    }

    getGrupoPoblacional(id: number): string {
        if (!this.grupoPoblacional || this.grupoPoblacional.length === 0) {
            return '';
        }
        const param = this.grupoPoblacional.find((p) => Number(p.id) === id);
        return param ? param.nombre : '';
    }

    getGrupoEtnico(id: number): string {
        if (!this.grupoSocial || this.grupoSocial.length === 0) {
            return '';
        }
        const param = this.grupoSocial.find((p) => Number(p.id) === id);
        return param ? param.nombre : '';
    }

    esOferta(): boolean {
        return !!this.eventData.vc_tittle_offer;
    }

    setTextoDinamico(): void {
        if (this.esOferta()) {
            this.textDinamico = 'oferta';
        } else {
            this.textDinamico = 'evento';
        }
    }

    setUrlProfile(urlProfile: string) {
        const baseUrl = window.location.origin;
        //console.log(baseUrl)
        const url = `/public/${urlProfile}`;
        this.urlCopiar = `${baseUrl}${url}`;
        this.router.navigate([url]);
    }

    saveInscripcion() {
        if (!this.searchService.loggedIn) {
            this.alertService.openInfoNotification('Atención', 'Para poder inscribirse debe estar inscrito en la plataforma');
            return;
        }

        if (this.fecha > this.data.date?.[0]?.vc_start_date) {
            this.alertService.openInfoNotification('Atención', 'El evento ya pasó, no puedes inscribirte');
            return;
        }

        const obj = {
            evento_user_uuid: this.data.vc_uuid_user,
            evento: this.data.i_pk_id,
        };

        const objOffer = {
            offer_user_uuid: this.data.vc_uuid_user,
            offer: this.data.i_pk_id,
        };

        if (this.esOferta()) {
            this.eventoService.saveInscripcionOffer(objOffer, this.data.vc_uuid).subscribe({
                next: () => {
                    this.alertService.openInfoNotification('Inscripción Registrada', '');

                    this.inscritoData = true;
                    this.data.subscribers = (this.data.subscribers || 0) + 1;
                    this.cdr.detectChanges();
                },
                error: (err) => {
                    if (err.status === 406) {
                        this.alertService.openInfoNotification('Atención', 'No te puedes autoinscribir a tu oferta');
                    }
                },
            });
        } else {
            this.eventoService.saveInscripcion(obj, this.data.vc_uuid).subscribe({
                next: () => {
                    this.alertService.openInfoNotification('Inscripción Registrada', '');

                    this.inscritoData = true;
                    this.data.subscribers = (this.data.subscribers || 0) + 1;
                    this.cdr.detectChanges();
                },
                error: (err) => {
                    console.log(err);
                    if (err.status === 406) {
                        this.alertService.openInfoNotification('Atención', 'No te puedes autoinscribir a tu oferta');
                    }
                },
            });
        }
    }

    deleteInscripcion() {
        if (!this.searchService.loggedIn) {
            this.alertService.openInfoNotification('Atención', 'Para poder inscribirse debe estar inscrito en la plataforma');
            return;
        }

        if (this.fecha > this.data.date?.[0]?.vc_start_date) {
            this.alertService.openInfoNotification('Atención', 'El evento ya pasó, no puedes cancelar la inscripción');
            return;
        }

        const obj = {
            evento_user_uuid: this.data.vc_uuid_user,
            evento: this.data.i_pk_id,
        };

        const objOffer = {
            offer_user_uuid: this.data.vc_uuid_user,
            offer: this.data.i_pk_id,
        };

        if (this.esOferta()) {
            this.eventoService.deleteInscripcionOffer(objOffer, this.data.vc_uuid).subscribe({
                next: () => {
                    this.alertService.openInfoNotification('Inscripción cancelada', '');

                    this.inscritoData = false;
                    this.data.subscribers = Math.max((this.data.subscribers || 1) - 1, 0);
                    this.cdr.detectChanges();
                },
                error: (err) => {
                    this.alertService.openDangerNotification('Error', 'No se pudo cancelar tu inscripción a esta oferta');
                },
            });
        } else {
            this.eventoService.deleteInscripcionEvent(obj, this.data.vc_uuid).subscribe({
                next: () => {
                    this.alertService.openInfoNotification('Inscripción cancelada', '');

                    this.inscritoData = false;
                    this.data.subscribers = Math.max((this.data.subscribers || 1) - 1, 0);
                    this.cdr.detectChanges();
                },
                error: (err) => {
                    this.alertService.openDangerNotification('Error', 'No se pudo cancelar tu inscripción a este evento');
                },
            });
        }
    }
}
